<script setup lang="ts">
import Page from '@/shared/components/layouts/Page.vue';
import MaintenanceSupportTypesWorkspace from '../../components/support-types/MaintenanceSupportTypesWorkspace.vue';

definePage({ meta: { title: 'Maintenance Support Types' } });
</script>

<template>
  <Page>
    <MaintenanceSupportTypesWorkspace />
  </Page>
</template>
